import * as React from "react";
import styled, { css } from "styled-components";
import { select } from "@hubper/theme";
import { Text } from "../..";

const Base = styled.div<{ selected: boolean }>`
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: ${select.speed("fast")};
  padding: 0 ${select.space(4)};
  box-sizing: border-box;
  color: ${p => select.color(["grey", p.selected ? 9 : 7])};
  ${p =>
    !p.selected &&
    css`
      &:hover {
        color: ${select.color(["grey", 9])};
      }
    `}
`;

const OpenItem = styled.div`
  padding: 4px;
  min-width: 18px;
  box-sizing: border-box;
  border-radius: 9px;
  background-color: ${select.color(["primary", 6])};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -12px;
  line-height: 10px;
  right: -20px;
  font-size: 10px;
  font-weight: bold;
  font-family: Lato;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  path: string;
  title: string;
  selected: boolean;
  onClick: (path: string) => void;
  openItems?: number;
};

function NavigationItem(
  { style, className, path, title, selected, onClick, openItems }: Props,
  ref: any
) {
  return (
    <Base
      ref={ref}
      style={style}
      className={className}
      onClick={() => onClick(path)}
      selected={selected}
    >
      <Text
        fs={-1}
        fw={selected ? "heavy" : "normal"}
        c="inherit"
        style={{ whiteSpace: "nowrap", position: "relative" }}
      >
        {title}
        {openItems ? <OpenItem>{openItems}</OpenItem> : null}
      </Text>
    </Base>
  );
}

export default React.forwardRef(NavigationItem);
